module.exports = __webpack_public_path__ + "img/137-Gris Quartz Lisse SFTN.jpg";